<template>
  <div>
    <p style="text-align=center;">
      <span class="systemFont0">{{ $t("p0102.companyStatistics") }}</span>
    </p>
    <p>
      <label class="systemFont1" style="color:#224268">{{
        $t("p0102.registrationNumbers")
      }}</label
      ><label class="systemFont0" style="color:#224268">{{
        this.userForm.companyAll
      }}</label>
    </p>
    <el-form
      ref="form"
      :model="userForm"
      label-width="80px"
      class="systemFont1"
    >
      <div>
        <el-row style="top: 17px">
          <el-col :span="22" :offset="1">
            <div class="mar">
              <!-- <el-form-item> --> 
              <el-date-picker
                :editable='false'
                :clearable='false'
                v-model="userForm.year"
                type="year"
                placeholder="选择年"
                style="width: 120px;"
                :picker-options="pickerOptions"
                @change="onYearChange"
                format="yyyy"
                value-format="yyyy"
              >
              </el-date-picker>
              <!-- </el-form-item> -->
            </div>
            <el-table
              :data="userForm.companyNumList"
              style="width: 100%; margin-bottom: 75px"
              :header-cell-style="{ textAlign: 'center' }"
              :cell-style="{ textAlign: 'center' }"
            >
              <el-table-column
                prop="month2"
                :label="$t('p0102.month')"
                min-width="4"
              >
              </el-table-column>
              <el-table-column
                prop="companyMonth"
                :label="$t('p0102.curMonthNumbers')"
                min-width="4"
              >
              </el-table-column>

              <el-table-column
                prop="companytotal"
                :label="$t('p0102.cumMonthNumbers')"
                min-width="4"
              >
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  // yearList: [2022,2023],
  data() {
    let _that = this;
    return {
      userForm: {
        // 公司、机构用户注册数量
        registrationNumber: "",
        // 年份，默认当前年份
        year: new Date().toISOString().substring(0, 4),
        // 表
        companyNumList: []
      },
      // 年份列表，默认当前年份
      yearList: [new Date().getFullYear()],
      pickerOptions: {
        disabledDate(time) {
          // console.log(time.getFullYear());
          return !_that.yearList.includes(time.getFullYear());
        }
      }
    };
  },

  mounted() {
    this.init();
    // 获取画面数据
    this.getCompNumber();
  },
  methods: {
    // 页面初始化,获取最早有公司注册过的年到现在的yearList
    init() {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      let url = "/api/monitor/company/year";
      // 访问对应后端的api获取画面数据
      this.$http
        .post(url, {})
        .then(response => {
          if (response.data.code === 200) {
            console.log("response.data" + this.response);
            this.yearList = response.data.data;
            // this.yearList = [2021,2022,2023]
          } else {
            loading.close();
            this.$message.error(response.data.message);
          }
          loading.close();
        })
        .catch(err => {
          loading.close();
          console.log(err);
          this.$message({
            message: "查询成功！",
            type: "success"
          });
        });
    },
    // 获取注册企业、机构统计画面信息
    getCompNumber() {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      let url = "/api/monitor/company/getCompanyNumber";
      // 访问对应后端的api获取画面数据
      this.$http
        .post(url, {
          year: this.userForm.year
          // registrationNumber: this.userForm.registrationNumber
        })
        .then(response => {
          // this.response = JSON.stringify(response.data);
          // this.userForm = response.data();
          if (response.data.code === 200) {
            console.log("response.data" + this.response);
            // this.userForm.years = response.data.data.year;
            this.userForm = response.data.data;
          } else {
            loading.close();
            this.$message.error(response.data.message);
          }
          // console.log("response.data"+this.response)
          // this.userForm=response.data.data
          loading.close();
        })
        .catch(err => {
          loading.close();
          console.log(err);
          this.$message({
            message: "查询成功！",
            type: "success"
          });
        });
    },
    // 点选年份触发重新获取统计信息
    onYearChange() {
      this.getCompNumber();
    }
  }
};
</script>

<style lang="scss" scoped>
>>> .mar {
  text-align: left;
}

>>> .itemStyleTop {
  text-align: left;
}

>>> .el-table {
  white-space: pre-wrap;
}

>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 16px;
}

>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}

>>> .el-table__row {
  height: 42px;
}

>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 0.5px solid rgb(170, 170, 170);
}

>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}

// /deep/ .el-input__prefix,
// /deep/ .el-input__icon {
//   line-height: 30px; // 可以通过设置行高改变图标在竖直方向上位置
// }
</style>



// WEBPACK FOOTER //
// src/views/UseMonitoring/P0102.vue